<script setup lang="ts">import AppHeader from '@/components/app/AppHeader.vue';</script>
<template><AppHeader/><main class="app-main"><slot/></main></template>
